import http from "../../http";

const BASE = "/gateway/syinfopublish/api/pc/information/v2";
const MENU = "/gateway/apps/oldpeople/api/pc/menu";

const informationCms = {
  queryDataPage(param) {
    return http.spin.get(`${BASE}/queryDataPage`, param);
  },
  queryById(param) {
    return http.get(`${BASE}/queryById`, param);
  },
  change(param) {
    return http.confirm.tip.post(`${BASE}/change`, param);
  },
  changeSilent(param) {
    return http.post(`${BASE}/change`, param);
  },
  changeIndexJson(param) {
    return http.payload(`${BASE}/changeIndexJson`, param);
  },
  changeFieldJson(param) {
    return http.payload(`${BASE}/changeFieldJson`, param);
  },
  deleteById(param) {
    return http.confirm.tip.post(`${BASE}/deleteById`, param);
  },
  groupStatus(param) {
    return http.get(`${BASE}/groupStatus`, param);
  },
  changeColumn(param) {
    return http.payload(`${BASE}/changeColumn`, param);
  },
  flushInformationTime(param) {
    return http.confirm.tip.post(`${BASE}/flushInformationTime`, param);
  },
  selectMenuByMenuCode(param) {
    return http.get(`${MENU}/selectMenuByMenuCode`, param);
  },
  selectHasOrgCode() {
    return http.get(`${BASE}/selectHasOrgCode`, {});
  },
  selectInformationTemplate(param) {
    return http.get("/gateway/syinfopublish/api/pc/information/template/selectInformationTemplate", param);
  },
  addInformationTemplate(param) {
    return http.confirm.tip.post("/gateway/syinfopublish/api/pc/information/template/addInformationTemplate", param);
  },
  selectTemplatePage(param) {
    return http.spin.get("/gateway/syinfopublish/api/pc/information/template/selectPage", param);
  },
  /** 通知记录分页 */
  selectMessagePage(param) {
    return http.spin.get(`${BASE}/selectMessagePage`, param);
  },
  /** 备注推送消息（idList 逗号分隔） */
  remarkMessage(param) {
    return http.post(`${BASE}/remarkMessage`, param);
  },
  /** 修改参与记录取消状态（排号等） */
  changeRecordState(param) {
    return http.post(`${BASE}/changeRecordState`, param);
  },
};

export default informationCms;
